module.exports = __webpack_public_path__ + "img/ui_sleep.8f97e369.jpg";